import {
  LOAD_PRODUCT_MODELS_FILTER_OPTIONS_FULFILLED,
  LOAD_PRODUCT_MODELS_FILTER_OPTIONS_PENDING,
  LOAD_PRODUCT_MODELS_FILTER_OPTIONS_REJECTED,
  LOAD_NEW_PRODUCT_MODELS_FULFILLED,
  LOAD_NEW_PRODUCT_MODELS_PENDING,
  LOAD_NEW_PRODUCT_MODELS_REJECTED,
  LOAD_PRODUCT_MODELS_FULFILLED,
  LOAD_PRODUCT_MODELS_PENDING,
  LOAD_PRODUCT_MODELS_REJECTED,
  LOAD_NEW_PRODUCT_MODELS_VARIANTS_FULFILLED,
  LOAD_NEW_PRODUCT_MODELS_VARIANTS_PENDING,
  LOAD_NEW_PRODUCT_MODELS_VARIANTS_REJECTED,
  LOAD_ADMIN_PRODUCT_TYPES_BY_ID_FULFILLED,
  LOAD_ADMIN_PRODUCT_TYPES_BY_ID_PENDING,
  LOAD_ADMIN_PRODUCT_TYPES_BY_ID_REJECTED,
  LOAD_ADMIN_PRODUCT_TYPES_FULFILLED,
  LOAD_ADMIN_PRODUCT_TYPES_PENDING,
  LOAD_ADMIN_PRODUCT_TYPES_REJECTED,
  LOAD_NEW_ADMIN_PRODUCT_TYPES_FULFILLED,
  LOAD_NEW_ADMIN_PRODUCT_TYPES_PENDING,
  LOAD_NEW_ADMIN_PRODUCT_TYPES_REJECTED,
  LOAD_PRODUCT_MODELS_VARIANTS_FULFILLED,
  LOAD_PRODUCT_MODELS_VARIANTS_PENDING,
  LOAD_PRODUCT_MODELS_VARIANTS_REJECTED,
  POST_PRODUCT_MODELS_VARIANTS_PENDING,
  POST_PRODUCT_MODELS_VARIANTS_FULFILLED,
  POST_PRODUCT_MODELS_VARIANTS_REJECTED,
  POST_PRODUCT_MODELS_PENDING,
  POST_PRODUCT_MODELS_FULFILLED,
  POST_PRODUCT_MODELS_REJECTED,
  POST_ADMIN_PRODUCT_TYPES_PENDING,
  POST_ADMIN_PRODUCT_TYPES_FULFILLED,
  POST_ADMIN_PRODUCT_TYPES_REJECTED,
  PUT_PRODUCT_MODELS_VARIANTS_PENDING,
  PUT_PRODUCT_MODELS_VARIANTS_FULFILLED,
  PUT_PRODUCT_MODELS_VARIANTS_REJECTED,
  PUT_PRODUCT_MODELS_PENDING,
  PUT_PRODUCT_MODELS_FULFILLED,
  PUT_PRODUCT_MODELS_REJECTED,
  PUT_ADMIN_PRODUCT_TYPES_PENDING,
  PUT_ADMIN_PRODUCT_TYPES_FULFILLED,
  PUT_ADMIN_PRODUCT_TYPES_REJECTED,
  DELETE_PRODUCT_MODELS_VARIANTS_PENDING,
  DELETE_PRODUCT_MODELS_VARIANTS_FULFILLED,
  DELETE_PRODUCT_MODELS_VARIANTS_REJECTED,
  LOAD_PRODUCT_MODELS_BY_ID_FULFILLED,
  LOAD_PRODUCT_MODELS_BY_ID_PENDING,
  LOAD_PRODUCT_MODELS_BY_ID_REJECTED,
  LOAD_NEW_PRODUCT_MODELS_IMAGES_FULFILLED,
  LOAD_NEW_PRODUCT_MODELS_IMAGES_PENDING,
  LOAD_NEW_PRODUCT_MODELS_IMAGES_REJECTED,
  DELETE_PRODUCT_MODELS_PENDING,
  DELETE_PRODUCT_MODELS_FULFILLED,
  DELETE_PRODUCT_MODELS_REJECTED,
  DELETE_ADMIN_PRODUCT_TYPES_PENDING,
  DELETE_ADMIN_PRODUCT_TYPES_FULFILLED,
  DELETE_ADMIN_PRODUCT_TYPES_REJECTED,
  LOAD_PRODUCT_MODELS_IMAGES_FULFILLED,
  LOAD_PRODUCT_MODELS_IMAGES_PENDING,
  LOAD_PRODUCT_MODELS_IMAGES_REJECTED,
  POST_PRODUCT_MODELS_IMAGES_PENDING,
  POST_PRODUCT_MODELS_IMAGES_FULFILLED,
  POST_PRODUCT_MODELS_IMAGES_REJECTED,
  DELETE_PRODUCT_MODELS_IMAGES_PENDING,
  DELETE_PRODUCT_MODELS_IMAGES_FULFILLED,
  DELETE_PRODUCT_MODELS_IMAGES_REJECTED,
  CLEAR_PRODUCT_MODELS_MESSAGES,
  DOWNLOAD_PRODUCT_MODELS_VARIANTS_FULFILLED,
  DOWNLOAD_PRODUCT_MODELS_VARIANTS_REJECTED,
  DOWNLOAD_PRODUCT_MODELS_VARIANTS_PENDING,
} from '../actions/productModels'
import i18n from 'i18next'

export default function productManagement(state = {}, action) {
  const unwrap = (p) => p?.data?.data ?? p?.data ?? p
  const asItem = (p) => {
    const v = unwrap(p)
    return Array.isArray(v) ? v[0] : v
  }

  switch (action.type) {
    case LOAD_NEW_PRODUCT_MODELS_VARIANTS_PENDING:
    case LOAD_PRODUCT_MODELS_VARIANTS_PENDING:
    case LOAD_ADMIN_PRODUCT_TYPES_BY_ID_PENDING:
    case LOAD_NEW_PRODUCT_MODELS_PENDING:
    case LOAD_PRODUCT_MODELS_PENDING:
    case LOAD_PRODUCT_MODELS_BY_ID_PENDING:
    case LOAD_NEW_ADMIN_PRODUCT_TYPES_PENDING:
    case LOAD_ADMIN_PRODUCT_TYPES_PENDING:
    case LOAD_PRODUCT_MODELS_FILTER_OPTIONS_PENDING:
    case POST_PRODUCT_MODELS_VARIANTS_PENDING:
    case POST_PRODUCT_MODELS_PENDING:
    case POST_ADMIN_PRODUCT_TYPES_PENDING:
    case PUT_PRODUCT_MODELS_VARIANTS_PENDING:
    case PUT_PRODUCT_MODELS_PENDING:
    case PUT_ADMIN_PRODUCT_TYPES_PENDING:
    case DELETE_PRODUCT_MODELS_VARIANTS_PENDING:
    case LOAD_NEW_PRODUCT_MODELS_IMAGES_PENDING:
    case LOAD_PRODUCT_MODELS_IMAGES_PENDING:
    case POST_PRODUCT_MODELS_IMAGES_PENDING:
    case DELETE_PRODUCT_MODELS_IMAGES_PENDING:
    case DELETE_PRODUCT_MODELS_PENDING:
    case DELETE_ADMIN_PRODUCT_TYPES_PENDING:
    case DOWNLOAD_PRODUCT_MODELS_VARIANTS_PENDING:
      return {
        ...state,
        isLoading: true,
        successMessage: null,
        errorMessage: null,
      }
    case LOAD_NEW_PRODUCT_MODELS_REJECTED:
    case LOAD_PRODUCT_MODELS_REJECTED:
    case LOAD_NEW_ADMIN_PRODUCT_TYPES_REJECTED:
    case LOAD_ADMIN_PRODUCT_TYPES_BY_ID_REJECTED:
    case LOAD_ADMIN_PRODUCT_TYPES_REJECTED:
    case LOAD_NEW_PRODUCT_MODELS_VARIANTS_REJECTED:
    case LOAD_PRODUCT_MODELS_VARIANTS_REJECTED:
    case LOAD_PRODUCT_MODELS_BY_ID_REJECTED:
    case LOAD_PRODUCT_MODELS_FILTER_OPTIONS_REJECTED:
    case POST_PRODUCT_MODELS_VARIANTS_REJECTED:
    case POST_PRODUCT_MODELS_REJECTED:
    case POST_ADMIN_PRODUCT_TYPES_REJECTED:
    case PUT_PRODUCT_MODELS_VARIANTS_REJECTED:
    case PUT_PRODUCT_MODELS_REJECTED:
    case PUT_ADMIN_PRODUCT_TYPES_REJECTED:
    case DELETE_PRODUCT_MODELS_VARIANTS_REJECTED:
    case LOAD_NEW_PRODUCT_MODELS_IMAGES_REJECTED:
    case LOAD_PRODUCT_MODELS_IMAGES_REJECTED:
    case POST_PRODUCT_MODELS_IMAGES_REJECTED:
    case DELETE_PRODUCT_MODELS_IMAGES_REJECTED:
    case DELETE_PRODUCT_MODELS_REJECTED:
    case DELETE_ADMIN_PRODUCT_TYPES_REJECTED:
    case DOWNLOAD_PRODUCT_MODELS_VARIANTS_REJECTED: {
      let errorCode
      try {
        const body = action.payload?.response?.body
        errorCode = typeof body === 'string' ? JSON.parse(body)?.code : body?.code
      } catch {
        // fallback if body isn't valid JSON
      }
      errorCode = errorCode || action.payload?.response?.data?.code
      return {
        ...state,
        isLoading: false,
        errorMessage: i18n.t([`error.${errorCode}`, 'error.something_wrong']),
      }
    }
    case LOAD_PRODUCT_MODELS_FILTER_OPTIONS_FULFILLED:
      return {
        ...state,
        productModelsFilterOptions: action.payload || [],
        isLoading: false,
      }
    case LOAD_PRODUCT_MODELS_VARIANTS_FULFILLED: {
      const existing = state?.productModelsVariants || []
      const incoming = action.payload?.data || []
      const incomingIds = new Set(incoming.map((it) => it.id))
      const merged = existing.filter((x) => !incomingIds.has(x.id)).concat(incoming)
      return {
        ...state,
        productModelsVariants: merged,
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    }
    case LOAD_NEW_PRODUCT_MODELS_VARIANTS_FULFILLED:
      return {
        ...state,
        productModelsVariants: action.payload?.data || [],
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    case POST_PRODUCT_MODELS_VARIANTS_FULFILLED: {
      const created = action.payload?.data ?? action.payload
      const list = state?.productModelsVariants || []
      return {
        ...state,
        productModelsVariants: [created, ...list],
        isLoading: false,
        successMessage: i18n.t('product_models_context.variant_created_successfully'),
      }
    }
    case PUT_PRODUCT_MODELS_VARIANTS_FULFILLED: {
      const updated = action.payload
      const list = state?.productModelsVariants || []
      const nextList = list.map((it) => (it.id === updated.id ? updated : it))
      const nextDetails = state?.selectedVariantDetails && state.selectedVariantDetails.id === updated.id ? updated : state.selectedVariantDetails
      return {
        ...state,
        productModelsVariants: nextList,
        selectedVariantDetails: nextDetails,
        isLoading: false,
        successMessage: i18n.t('product_models_context.variant_updated_successfully'),
      }
    }
    case DELETE_PRODUCT_MODELS_VARIANTS_FULFILLED: {
      const id = action.meta?.variantsId
      const next = (state?.productModelsVariants || []).filter((item) => item.id !== id)
      const nextDetails = state.selectedVariantDetails && state.selectedVariantDetails.id === id ? null : state.selectedVariantDetails
      return {
        ...state,
        productModelsVariants: next,
        selectedVariantDetails: nextDetails,
        isLoading: false,
        successMessage: i18n.t('product_models_context.variant_deleted_successfully'),
      }
    }
    case DOWNLOAD_PRODUCT_MODELS_VARIANTS_FULFILLED:
      return {
        ...state,
        productModelVariantsCSV: action.payload?.data || [],
        isLoading: false,
      }
    case LOAD_PRODUCT_MODELS_FULFILLED: {
      const existing = state?.productModels || []
      const incoming = action.payload?.data || []
      const incomingIds = new Set(incoming.map((it) => it.id))
      const merged = existing.filter((x) => !incomingIds.has(x.id)).concat(incoming)
      return {
        ...state,
        productModels: merged,
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    }
    case LOAD_NEW_PRODUCT_MODELS_FULFILLED:
      return {
        ...state,
        productModels: action.payload?.data || [],
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    case LOAD_PRODUCT_MODELS_BY_ID_FULFILLED:
      return {
        ...state,
        productModelsById: action.payload?.data || [],
        isLoading: false,
      }
    case PUT_PRODUCT_MODELS_FULFILLED: {
      const updated = asItem(action.payload)
      const list = state?.productModels || []
      const nextList = list.map((it) => (it.id === updated.id ? updated : it))
      return {
        ...state,
        productModels: nextList,
        isLoading: false,
        successMessage: i18n.t('product_models_context.model_updated_successfully'),
      }
    }
    case POST_PRODUCT_MODELS_FULFILLED: {
      const created = asItem(action.payload)
      const list = state?.productModels || []
      return {
        ...state,
        productModels: [created, ...list],
        isLoading: false,
        successMessage: i18n.t('product_models_context.model_created_successfully'),
      }
    }
    case DELETE_PRODUCT_MODELS_FULFILLED: {
      const id = action.meta?.modelId
      const next = (state?.productModels || []).filter((item) => item.id !== id)
      return {
        ...state,
        productModels: next,
        isLoading: false,
        successMessage: i18n.t('product_models_context.model_deleted_successfully'),
      }
    }
    case LOAD_ADMIN_PRODUCT_TYPES_FULFILLED: {
      const existing = state?.productTypes || []
      const incoming = action.payload?.data || []
      const incomingIds = new Set(incoming.map((it) => it.id))
      const merged = existing.filter((x) => !incomingIds.has(x.id)).concat(incoming)
      return {
        ...state,
        productTypes: merged,
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    }
    case LOAD_NEW_ADMIN_PRODUCT_TYPES_FULFILLED:
      return {
        ...state,
        productTypes: action.payload?.data || [],
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    case LOAD_ADMIN_PRODUCT_TYPES_BY_ID_FULFILLED:
      return {
        ...state,
        productTypesById: action.payload?.data || [],
        isLoading: false,
      }
    case PUT_ADMIN_PRODUCT_TYPES_FULFILLED: {
      const updated = asItem(action.payload)
      const list = state?.productTypes || []
      const nextList = list.map((it) => (it.id === updated.id ? updated : it))
      return {
        ...state,
        productTypes: nextList,
        isLoading: false,
        successMessage: i18n.t('product_models_context.product_type_updated_successfully'),
      }
    }
    case POST_ADMIN_PRODUCT_TYPES_FULFILLED: {
      const created = asItem(action.payload)
      const list = state?.productTypes || []
      return {
        ...state,
        productTypes: [created, ...list],
        isLoading: false,
        successMessage: i18n.t('product_models_context.product_type_created_successfully'),
      }
    }
    case DELETE_ADMIN_PRODUCT_TYPES_FULFILLED: {
      const id = action.meta?.id
      const next = (state?.productTypes || []).filter((item) => item.id !== id)
      return {
        ...state,
        productTypes: next,
        isLoading: false,
        successMessage: i18n.t('product_models_context.product_type_deleted_successfully'),
      }
    }
    case LOAD_PRODUCT_MODELS_IMAGES_FULFILLED: {
      const existing = state?.productModelsImages || []
      const incoming = action.payload?.data || []
      const incomingIds = new Set(incoming.map((it) => it.id))
      const merged = existing.filter((x) => !incomingIds.has(x.id)).concat(incoming)
      return {
        ...state,
        productModelsImages: merged,
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    }
    case LOAD_NEW_PRODUCT_MODELS_IMAGES_FULFILLED:
      return {
        ...state,
        productModelsImages: action.payload?.data || [],
        canLoadMore: action.payload?.nextPage,
        isLoading: false,
      }
    case POST_PRODUCT_MODELS_IMAGES_FULFILLED: {
      const created = action.payload?.data ?? action.payload
      const list = state?.productModelsImages || []
      return {
        ...state,
        productModelsImages: [created, ...list],
        isLoading: false,
        successMessage: i18n.t('product_models_context.image_added_successfully'),
      }
    }
    case DELETE_PRODUCT_MODELS_IMAGES_FULFILLED: {
      const id = action.meta?.id
      const next = (state?.productModelsImages || []).filter((item) => item.id !== id)
      const nextDetails = state.selectedImageDetails && state.selectedImageDetails.id === id ? null : state.selectedImageDetails
      return {
        ...state,
        productModelsImages: next,
        selectedImageDetails: nextDetails,
        isLoading: false,
        successMessage: i18n.t('product_models_context.image_deleted_successfully'),
      }
    }
    case CLEAR_PRODUCT_MODELS_MESSAGES:
      return {
        ...state,
        successMessage: null,
        errorMessage: null,
      }
    default:
      return state
  }
}
